export const PRODUCTS: { id: number; label: string; value: string }[] = [
  {
    id: 1,
    label: 'තාරා බූන්දී',
    value: 'Thara Boondi',
  },
  {
    id: 2,
    label: 'මස්කට්',
    value: 'Muscat',
  },
  {
    id: 3,
    label: 'පුහුල් දෝසි',
    value: 'Puhul Dosi',
  },
  {
    id: 4,
    label: 'ජුජුබ්ස්',
    value: 'Jujubes',
  },
  {
    id: 5,
    label: 'හකුරු',
    value: 'Hakuru',
  },
  {
    id: 6,
    label: 'පැණි කජු',
    value: 'Peni Kaju',
  },
  {
    id: 7,
    label: 'රුලං',
    value: 'Rulan',
  },
  {
    id: 8,
    label: 'ගල් මස්කට්',
    value: 'Gal Mascat',
  },
  {
    id: 7,
    label: 'පොරි බෝල',
    value: 'Pori Bola',
  },
  {
    id: 8,
    label: 'මල් පොරි',
    value: 'Mal Pori',
  },
  {
    id: 9,
    label: 'මල් පොරි',
    value: 'Mal Pori',
  },
  {
    id: 10,
    label: 'මාශ්මෙලෝ',
    value: 'Marshmellow',
  },
  {
    id: 11,
    label: 'කහ කඩල ',
    value: 'Kaha Kadala',
  },
  {
    id: 12,
    label: 'කලු කඩල',
    value: 'Kalu Kadala',
  },
  {
    id: 13,
    label: 'තල කැරලි',
    value: 'Thala Kerali',
  },
  {
    id: 14,
    label: 'මසාලා රටකජු',
    value: 'Masala Ratakaju',
  },
  {
    id: 15,
    label: 'රට කජු',
    value: 'Ratakaju',
  },
  {
    id: 16,
    label: 'මික්ස්චර්',
    value: 'Mixture',
  },
  {
    id: 17,
    label: 'ඉන්දියන් මික්ස්චර්',
    value: 'Indian Mixture',
  },
  {
    id: 18,
    label: 'අනියන් බයිට්ස්',
    value: 'Onion Bites',
  },
  {
    id: 19,
    label: 'බොක්ස් බයිට්',
    value: 'Box Bite',
  },
  {
    id: 19,
    label: 'ග්‍රීන් පීස්',
    value: 'Green Peas',
  },
  {
    id: 20,
    label: 'චීස් බයිට්',
    value: 'Cheese Bite',
  },
  {
    id: 21,
    label: 'සුදු ලූනූ බයිට්',
    value: 'Sudulunu Bite',
  },
  {
    id: 22,
    label: 'සීනී මුරුක්කු',
    value: 'Seeni Murukku',
  },
  {
    id: 23,
    label: 'කජු බෝල',
    value: 'Kaju Bola',
  },
  {
    id: 24,
    label: 'මිරිස් කඩල',
    value: 'Miris Kadala',
  },
  {
    id: 25,
    label: 'පරිප්පු',
    value: 'Parippu',
  },
];

export function findProducts(stringValue: string): any[] {
  const products: any[] = [];

  stringValue.split('|').forEach((value) => {
    const product = PRODUCTS.find((item) => item.value === value);

    if (product) {
      products.push(product);
    }
  });

  return products;
}
